"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverageDefinitionList = exports.createCoverageDefinitionList = void 0;
var tslib_1 = require("tslib");
var string_formatters_1 = require("@newfront-insurance/string-formatters");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var definition_list_1 = require("../definition-list");
function renderName(policyType, displayName) {
    if (displayName) {
        return "".concat(policyType, " - ").concat(displayName);
    }
    return policyType;
}
function createCoverageDefinitionList(enrichedLineOfCoverage) {
    var startDate = enrichedLineOfCoverage.startDate, endDate = enrichedLineOfCoverage.endDate;
    var _a = enrichedLineOfCoverage.policy, name = _a.name, policyNumber = _a.policyNumber, type = _a.type;
    var items = [
        {
            type: 'document',
            title: 'Policy',
            value: renderName(type, name),
        },
        {
            type: 'number',
            title: 'Policy number',
            value: policyNumber,
            href: '#',
        },
        {
            type: 'dateRange',
            title: 'Effective dates',
            value: "".concat((0, string_formatters_1.standardDateFormat)(startDate), " - ").concat((0, string_formatters_1.standardDateFormat)(endDate)),
        },
    ];
    return items;
}
exports.createCoverageDefinitionList = createCoverageDefinitionList;
function CoverageDefinitionList(props) {
    var coverageDefinition = props.coverageDefinition, hideTitle = props.hideTitle;
    return (react_1.default.createElement(definition_list_1.DefinitionList, { hideTitle: hideTitle, items: createCoverageDefinitionList(coverageDefinition), labelWidth: "150px" }));
}
exports.CoverageDefinitionList = CoverageDefinitionList;
//# sourceMappingURL=index.js.map